import { render } from "./LandlordsPage.vue?vue&type=template&id=2913d53a&scoped=true"
import script from "./LandlordsPage.vue?vue&type=script&lang=js"
export * from "./LandlordsPage.vue?vue&type=script&lang=js"

import "./LandlordsPage.vue?vue&type=style&index=0&id=2913d53a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2913d53a"]])

export default __exports__